module.exports = __webpack_public_path__ + "opensource-forum-fe/static/img/avatar.478e4507.png";